import { Link } from 'react-router-dom';
import { Gamepad2, User, LogOut, Moon, Sun } from 'lucide-react';
import AdminTagButton from './AdminTagButton';

function Navbar({ user, logout, openAuthModal, theme, toggleTheme, token }) {
  return (
    <nav className="sticky top-0 z-50 backdrop-blur supports-[backdrop-filter]:bg-background/60 border-b border-border" style={{ background: 'linear-gradient(145deg, #762b9e, #4235c1)' }}>
      <div className="container mx-auto px-3 sm:px-4">
        <div className="flex items-center justify-between h-14 sm:h-16">
          <Link to="/" className="flex items-center space-x-2 text-lg sm:text-xl">
            <img src="/logo.png" alt="GameFeed.io" className="h-7 sm:h-8 w-auto" />
            <span className="text-white font-medium hidden sm:inline">
              GameFeed.io
            </span>
          </Link>
          
          <div className="flex items-center gap-1 sm:gap-2">
            {user ? (
              <>
                <AdminTagButton user={user} token={token} />
                <button
                  onClick={toggleTheme}
                  className="p-2 rounded-lg hover:bg-white/10 transition-colors text-white"
                  data-testid="theme-toggle"
                  aria-label="Toggle theme"
                >
                  {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </button>
                <Link 
                  to="/profile"
                  className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg hover:bg-white/10 transition-colors text-white"
                  data-testid="profile-link"
                >
                  <User className="w-5 h-5" />
                  <span className="hidden sm:inline">{user.name}</span>
                </Link>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 px-3 sm:px-4 py-2 rounded-lg hover:bg-white/10 transition-colors text-white"
                  data-testid="logout-button"
                >
                  <LogOut className="w-5 h-5" />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </>
            ) : (
              <>
                <button
                  onClick={toggleTheme}
                  className="p-2 rounded-lg hover:bg-white/10 transition-colors text-white"
                  data-testid="theme-toggle"
                  aria-label="Toggle theme"
                >
                  {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
                </button>
                <button
                  onClick={() => openAuthModal('login')}
                  className="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium rounded-lg hover:bg-white/10 transition-colors text-white"
                  data-testid="login-button"
                >
                  Login
                </button>
                <button
                  onClick={() => openAuthModal('signup')}
                  className="px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium bg-white text-purple-900 rounded-lg hover:bg-white/90 transition-colors"
                  data-testid="signup-button"
                >
                  Sign Up
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;